'use client';

import posthog from 'posthog-js';
import { PostHogProvider as CSPostHogProvider } from 'posthog-js/react';

import { isClient, isTestingEnv } from '@/app/_utils/env';

if (isClient() && !isTestingEnv()) {
  posthog.init('phc_grTQOyqTTh9P5EZhZ7ukGVPb30v0RJbSJJRqorkXXEy', {
    api_host: '/ingest',
    person_profiles: 'always',
    capture_pageview: true
  });
}

type PostHogProviderProps = {
  children: React.ReactNode;
};

export const PostHogProvider = ({ children }: PostHogProviderProps) => {
  return <CSPostHogProvider client={posthog}>{children}</CSPostHogProvider>;
};
